import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthStore } from "../pages/auth/store/auth.store";

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authStore = inject(AuthStore);

  const expectedRoles: any[] = route.data["roles"];
  if (expectedRoles.includes(authStore.role())) return true;

  router.navigate(["/home/403-forbidden"], {
    queryParams: { requiredParams: expectedRoles },
  });
  return false;
};
